export const watchLivePersonChatAction = {
  initial: 'idle',
  invoke: {
    src: 'watchLivePersonChatAction',
  },
  states: {
    idle: {
      on: {
        CASHIER_LIVE_CHAT_OPEN: [
          {
            actions: ['cashierOpenLiveChat'],
          },
        ],
      },
    },
  },
};
